import { ClientSubscriptionItem, defaultClientSubscription } from 'app/features/admin/clients/model/ClientSubscription';
import { SubscriptionLengthType, SubscriptionType } from 'app/core/models/common-types';

const features1: string[] = [
  'Get Sport Recommendations',
  'Access to our Customer Portal',
  'View Recommendations on any device',
  'Analysis summaries',
  'Automated Updates',
];
const features2: string[] = ['Automated Updates', 'Automated Alerts'];

const features3: string[] = [];

export const clientSubscriptionData: ClientSubscriptionItem[] = [
  {
    ...defaultClientSubscription,
    subscriptionType: SubscriptionType.BASIC,
    monthlyPrice: 99,
    yearlyPrice: 999,
    subscriptionLengthType: SubscriptionLengthType.MONTHLY,
    buttonTitle: 'Sign Up Basic',
    features: [...features1, '8-12 recommendations weekly'],
    startDatePayload: null,
    endDatePayload: null,
  },
  {
    ...defaultClientSubscription,
    subscriptionType: SubscriptionType.PREMIUM,
    monthlyPrice: 129,
    yearlyPrice: 1199,
    subscriptionLengthType: SubscriptionLengthType.MONTHLY,
    buttonTitle: 'Sign Up Premium',
    features: [...features1, '15-20 recommendations weekly'],
    startDatePayload: null,
    endDatePayload: null,
  },
  // {
  //   ...defaultClientSubscription,
  //   title: 'ENTERPRISE',
  //   description: 'For Contractors needing even more...',
  //   price: 119.99,
  //   subscriptionLengthType: SubscriptionLengthType.MONTHLY,
  //   buttonTitle: 'Request Feature(s)',
  //   features:[...features1, ...features2, ...features3]
  // },
];
